import path from 'path';
export function normalizePath(...paths) {
    const f = path.join(...paths).replaceAll('\\', '/');
    if (/^\.[/\\]/.test(paths[0]))
        return `./${f}`;
    return f;
}
